import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const NotesToFincen = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="generalInfo.filingNotesToFinCen"
      control={control}
      render={({ field }) => (
        <FF2 field={field} label={'2. Filing Institution Note to FinCEN'} input={(props) => <TextInput {...props} />} />
      )}
    />
  )
}
